export default __webpack_public_path__ + "static/media/Asset 3.4fe8ed38.svg";